import { createSlice } from "@reduxjs/toolkit";

const ToggleRegistModal = createSlice({
  name: "toggleRegModal",
  initialState: {
    LoginStatus: false,
    signUpStatus: false,
    NavigatePanelModal: false,
  },
  reducers: {
    toggleLoginStatus: (state) => {
      state.LoginStatus = !state.LoginStatus;
      state.signUpStatus = false;
      state.NavigatePanelModal = false;
    },
    toggleSignUpStatus: (state) => {
      state.signUpStatus = !state.signUpStatus;
      state.LoginStatus = false;
      state.NavigatePanelModal = false;
    },
    toggleNavigatePanel: (state) => {
      state.NavigatePanelModal = !state.NavigatePanelModal;
      state.LoginStatus = false;
      state.signUpStatus = false;
    },
    togRegModalToFalse: (state) => {
      state.LoginStatus = false;
      state.signUpStatus = false;
    },
  },
});
export const {
  toggleSignUpStatus,
  toggleLoginStatus,
  togRegModalToFalse,
  toggleNavigatePanel,
} = ToggleRegistModal.actions;
export default ToggleRegistModal.reducer;
